import React from "react";
import sidebarLogo from "icons/new-vt-logo-white.svg";
import docsLogo from "icons/new-vt-docs-white.svg";
import workspaceLogo from "icons/workspace.svg";
import profileLogo from "icons/profile.svg";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import ButtonsDropdownOption from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdownOption";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { setWorkspace } from "slices/app/actions/app";
import { htmlDecode } from "utils";

const NavBar = () => {
  const dispatch = useDispatch();
  // eslint-disable-next-line no-undef
  const { productVersion } = Application;
  const {
    userName,
    workspaceName,
    workspaces,
    location,
    bannerProperties,
    cloudMode,
    // eslint-disable-next-line no-undef
  } = UserInfo;
  const { navBarAndSideBarDisabled } = useSelector((state) => state.app);

  const workspacesButton = () => (
    <>
      <img src={workspaceLogo} alt="Workspace logo" />
      <span>{workspaceName}</span>
    </>
  );

  const workspacesOptions = () =>
    workspaces
      .filter((workspace) => workspace.workspaceName !== workspaceName)
      .map((workspace) => (
        <ButtonsDropdownOption
          content={workspace.workspaceName}
          onClick={() => {
            dispatch(setWorkspace(workspace.workspaceId));
          }}
        />
      ));

  const userOptionsButton = () => (
    <>
      <img src={profileLogo} alt="Profile logo" style={{ height: "18px" }} />
      <span>{userName}</span>
    </>
  );

  const userOptions = () => [
    <ButtonsDropdownOption
      content="Sign Out"
      onClick={() => {
        window.location.href = "/login/logout.jsp";
      }}
    />,
    <ButtonsDropdownOption
      content="Change Password"
      onClick={() => {
        dispatch(showModal(modalTypes.CHANGE_PASSWORD));
      }}
    />,
    <ButtonsDropdownOption
      content="Help"
      onClick={() => {
        window.location.href = "/help";
      }}
    />,
    <ButtonsDropdownOption
      content="About VisibleThread"
      onClick={() => {
        dispatch(showModal(modalTypes.ABOUT_VT_DOCS));
      }}
    />,
  ];

  return (
    <nav className="nav_bar" data-testid="navbar">
      <div className="nav_bar__left_area">
        <div className="nav_bar__sidebar_logo">
          <img src={sidebarLogo} alt="sidebar Logo" />
        </div>
        <div className="nav_bar__docs_logo">
          <Button
            variant={buttonVariants.borderless}
            content={<img src={docsLogo} alt="docs Logo" />}
            onClick={() => {}}
          />
        </div>
        <span className="nav_bar__product_version">{productVersion}</span>
        <span className="nav_bar__page_title">{location}</span>
      </div>
      <div className="nav_bar__right_area">
        {bannerProperties && bannerProperties.enabled && (
          <div
            className="nav_bar__right_area__banner_message"
            style={{
              color: bannerProperties.colour,
              background: bannerProperties.background,
            }}
          >
            {htmlDecode(bannerProperties.message)}
          </div>
        )}
        {workspaceName && workspaces.length > 1 && (
          <div className="nav_bar__workspaces">
            <Dropdown
              type={dropdownTypes.buttons}
              propsObject={{
                button: workspacesButton(),
                options: workspacesOptions(),
                buttonVariant: buttonVariants.borderless,
              }}
            />
          </div>
        )}
        {workspaceName && workspaces.length === 1 && !cloudMode && (
          <div className="nav_bar__workspaces single_workspace">
            {workspacesButton()}
          </div>
        )}
        <div className="nav_bar__user_options">
          <Dropdown
            type={dropdownTypes.buttons}
            propsObject={{
              button: userOptionsButton(),
              options: userOptions(),
              buttonVariant: buttonVariants.borderless,
            }}
          />
        </div>
      </div>
      {navBarAndSideBarDisabled && (
        <div className="nav_bar__disable_mask" data-testid="disable-mask" />
      )}
    </nav>
  );
};

export default NavBar;
